module.exports = __webpack_public_path__ + "static/media/pasamosagosto3.680f1e1f.jpg";